
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle } from "lucide-react";
import GlassCard from "@/components/ui/glass-card";
import { useSubscription } from "@/hooks/subscription";
import { toast } from "sonner";

const EmptyFormState = () => {
  const navigate = useNavigate();
  const { isSubscribed } = useSubscription();
  
  const handleCreateForm = () => {
    // Redirect to pricing if not subscribed
    if (!isSubscribed) {
      toast.info("Start your 7-day free trial to create investor forms");
      navigate("/pricing");
      return;
    }
    
    // If subscribed or on trial, navigate to forms page with create=true param
    console.log("EmptyFormState: Redirecting to forms with create=true param");
    navigate("/forms?create=true", { replace: true });
  };
  
  return (
    <GlassCard className="p-6 text-center">
      <div className="py-8">
        <div className="mb-4 text-muted-foreground">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <h3 className="text-lg font-medium mb-2">No forms yet</h3>
        <p className="text-muted-foreground mb-6">
          Create your first investor form to start collecting leads
        </p>
        <Button 
          onClick={handleCreateForm} 
          variant="outline"
        >
          <PlusCircle className="w-4 h-4 mr-2" />
          Create Your First Form
        </Button>
      </div>
    </GlassCard>
  );
};

export default EmptyFormState;
